import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RmAntibioticsReportInfo } from '../dto/rm-antibiotics-report.dto';
import { AntibioticsReportService } from './rm-antibiotics-report.service';
import { AntibioticsReq } from './rm-antibiotics-req';
import { RejectedIndentReq } from './indent-reject-req';

@ApiTags('Antibiotics Report')
@Controller('rm-antibiotics-report')
export class AnitibioticsReportController {

    constructor(
        private service: AntibioticsReportService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createAntibioticsInfo')
    async createAntibioticsInfo(@Body() info: any): Promise<CommonResponse>{
        try{
            return await this.service.createAntiBioticsTest(info);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    
@Post('/revertAntiBioticsTestStatus')
async revertAntiBioticsTestStatus(@Body() req: any): Promise<CommonResponse>{
    try{
        return await this.service.revertAntiBioticsTestStatus(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}

    @Post('/getAllAntiBioticsResult')
    async getAllAntiBioticsResult(@Body() req: AntibioticsReq): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsResult(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsPreHarvestData')
    async getAllAntiBioticsPreHarvestData(@Body() req:AntibioticsReq): Promise<CommonResponse>{
         console.log(req,'contr111111111')
        try{
            return await this.service.getAllAntiBioticsPreHarvestData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsGradingData')
    async getAllAntiBioticsGradingData(@Body() req:AntibioticsReq): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsGradingData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsRejectedIndentsData')
    async getAllAntiBioticsRejectedIndentsData(@Body() req:RejectedIndentReq): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsRejectedIndentsData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsFailedGrnNumbers')
    async getAllAntiBioticsFailedGrnNumbers(): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsFailedGrnNumbers();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsFailedCount')
    async getAllAntiBioticsFailedCount(): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsFailedCount();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsFailedIndentsNumbers')
    async getAllAntiBioticsFailedIndentsNumbers(): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsFailedIndentsNumbers();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAntiBioticsFailedFarmer')
    async getAllAntiBioticsFailedFarmer(): Promise<CommonResponse>{
        try{
            return await this.service.getAllAntiBioticsFailedFarmer();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/updateAntiBioticTest')
    async updateAntiBioticTest(@Body() info: any): Promise<CommonResponse> {
        try{
        return await this.service.updateAntiBioticTest(info);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}
}